import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../Common/Button';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 h-16 fixed top-0 right-0 left-0 lg:left-64 z-20">
      <div className="h-full px-4 md:px-6 flex items-center justify-between gap-4">
        {/* Bot\u00e3o hamburguer para mobile */}
        <button
          onClick={onMenuClick}
          className="lg:hidden text-gray-600 hover:text-gray-800 p-2 -ml-2"
          aria-label="Abrir menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <Link to="/perfil" className="hover:opacity-75 transition-opacity flex-1 min-w-0">
          <h2 className="text-base md:text-lg font-semibold text-gray-800 truncate">
            Bem-vindo, {user?.nome}!
          </h2>
          <p className="text-xs md:text-sm text-gray-500 truncate">{user?.tipo}</p>
        </Link>

        <Button variant="secondary" size="sm" onClick={logout} className="flex-shrink-0">
          Sair
        </Button>
      </div>
    </header>
  );
};

export default Header;
